<template>
  <div style="text-align:center">
    <div :style="style" ref="lavContainer" />
    <span v-if="title !== ''">{{title}}</span>
  </div>
</template>

<script>
import lottie from 'lottie-web'
export default {
  name: 'lottieLayout',
  props: {
    options: {
      type: Object,
      required: true
    },
    title: {
      type: String | Number,
      default: ''
    },
    height: Number,
    width: Number,
    speed: {
      type: Number,
      default: 1
    }
  },
  computed: {
    style () {
      return {
        width: this.width ? `${this.width}px` : '100%',
        height: this.height ? `${this.height}px` : '100%'
      }
    }
  },
  mounted () {
    let params = {
      container: this.$refs.lavContainer,
      renderer: 'svg',
      loop: this.options.loop !== false,
      autoplay: false
    }
    if (this.options.animationData.indexOf('http') === 0) {
      params.path = this.options.animationData
    } else {
      params.animationData = this.options.animationData
    }
    this.anim = lottie.loadAnimation(params)
    if (this.speed !== 1) {
      this.anim.setSpeed(this.speed)
    }
    this.anim.addEventListener('loopComplete', () => {
      this.$emit('loopComplete')
    })
    this.anim.addEventListener('complete', () => {
      this.$emit('complete')
    })
    if (this.options.autoplay !== false) {
      this.anim.play()
    }
  },
  unmounted () {
    if (this.anim) {
      this.anim.removeEventListener('loopComplete')
      this.anim.removeEventListener('complete')
      this.anim.destroy()
    }
  },
  methods: {
    play () {
      if (this.anim) {
        this.anim.play()
      }
    },
    stop () {
      if (this.anim) {
        this.anim.stop()
      }
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/global/lottie/lottieLayout.vue